"use strict";
import { CANVAS_SIZE_CHANGED } from "../actions";
export default function canvasReducer(canvas = {}, action) {
  switch (action.type) {
    case CANVAS_SIZE_CHANGED: {
      return Object.assign({}, canvas, {
        width: action.width,
        height: action.height
      });
    }
    default:
      return canvas;
  }
}
